import API, { apiErrorMessage } from "../global/api";
import { listPaging } from "../global/Utils";

// Add User
export const addUserRequest = () => {
  return {
    type: "ADD_USER_REQUEST",
  };
};
export const addUserSuccess = (data) => {
  return {
    type: "ADD_USER_SUCCESS",
    payload: data,
  };
};
export const addUserError = (msg) => {
  return {
    type: "ADD_USER_ERROR",
    payload: msg,
  };
};
export const addUser = (
  data,
  setFormData,
  handleVisible,
  handleDangerVisible,
) => {
  return (dispatch) => {
    dispatch(addUserRequest());
    API.post(`/auth/register`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(addUserSuccess(data1));
        handleVisible(res.data.message);
        setFormData({
          email: "",
          password: "",
          userName: "",
          role: "",
          allowCompanies: 0,
          allowInvoices: 0,
          activeDate: "",
          expireDate: "",
          subscriptionInterval: "",
          appMode: [],
        });
      })
      .catch((error) => {
        dispatch(addUserError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Getting User List
export const getUserListRequest = () => {
  return {
    type: "USER_LIST_REQUEST",
  };
};
export const getUserListSuccess = (data) => {
  return {
    type: "USER_LIST_SUCCESS",
    payload: data,
  };
};
export const getUserListError = (msg) => {
  return {
    type: "USER_LIST_ERROR",
    payload: msg,
  };
};
export const getUserList = (page, limit, globalFilter, role) => {
  return (dispatch) => {
    dispatch(getUserListRequest());
    const paging = listPaging(page, limit);
    API.get(
      `/user/get-users?page=${paging.page}&limit=${paging.limit}&search=${globalFilter}&role=${role}`,
    )
      .then((res) => {
        let userList = res.data;
        dispatch(getUserListSuccess(userList));
      })
      .catch((error) => {
        dispatch(getUserListError(apiErrorMessage(error)));
      });
  };
};

// Block User List
export const changeUserStatusRequest = () => {
  return {
    type: "BLOCK_USER_REQUEST",
  };
};
export const changeUserStatusSuccess = (data) => {
  return {
    type: "BLOCK_USER_SUCCESS",
    payload: data,
  };
};
export const changeUserStatusError = (msg) => {
  return {
    type: "BLOCK_USER_ERROR",
    payload: msg,
  };
};
export const changeUserStatus = (
  id,
  data,
  handleVisible,
  handleDangerVisible,
  page,
  limit,
  globalFilter,
  statusFromDashboard,
  handleClose,
) => {
  return (dispatch) => {
    dispatch(changeUserStatusRequest());
    API.post(`/user/change-user-status/${id}`, data)
      .then((res) => {
        let responseData = res?.data;
        dispatch(changeUserStatusSuccess(responseData));
        handleVisible(res.data.message);
        if (handleClose) handleClose();
        dispatch(getUserList(page, limit, globalFilter, statusFromDashboard));
      })
      .catch((error) => {
        dispatch(changeUserStatusError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Updating User List
export const updateUserListRequest = () => {
  return {
    type: "UPDATE_USER_LIST_REQUEST",
  };
};
export const updateUserListSuccess = (data) => {
  return {
    type: "UPDATE_USER_LIST_SUCCESS",
    payload: data,
  };
};
export const updateUserListError = (msg) => {
  return {
    type: "UPDATE_USER_LIST_ERROR",
    payload: msg,
  };
};
export const updateUserList = (
  id,
  data,
  handleVisible,
  handleDangerVisible,
  navigate,
) => {
  return (dispatch) => {
    dispatch(updateUserListRequest());
    API.put(`/user/update-user/${id}`, data)
      .then((res) => {
        let updateUserList = res.data;
        dispatch(updateUserListSuccess(updateUserList));
        handleVisible(res.data.message, () => navigate("/main/view-user-list"));
      })
      .catch((error) => {
        dispatch(updateUserListError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Is Changing User Password
export const changeUserPasswordRequest = () => {
  return {
    type: "CHANGE_USER_PASSWORD_REQUEST",
  };
};
export const changeUserPasswordSuccess = (data) => {
  return {
    type: "CHANGE_USER_PASSWORD_SUCCESS",
    payload: data,
  };
};
export const changeUserPasswordError = (msg) => {
  return {
    type: "CHANGE_USER_PASSWORD_ERROR",
    payload: msg,
  };
};
export const changeUserPassword = (
  id,
  data,
  handleVisible,
  handleDangerVisible,
  handleClose,
) => {
  return (dispatch) => {
    dispatch(changeUserPasswordRequest());
    API.post(`/user/admin-change-user-password/${id}`, data)
      .then((res) => {
        let changeUserPassword = res.data;
        dispatch(changeUserPasswordSuccess(changeUserPassword));
        handleVisible(res.data.message);
        handleClose();
      })
      .catch((error) => {
        dispatch(changeUserPasswordError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Is getting company with User
export const getCompanyWithUserRequest = () => {
  return {
    type: "GET_COMPANY_WITH_USER_REQUEST",
  };
};
export const getCompanyWithUserSuccess = (data) => {
  return {
    type: "GET_COMPANY_WITH_USER_SUCCESS",
    payload: data,
  };
};
export const getCompanyWithUserError = (msg) => {
  return {
    type: "GET_COMPANY_WITH_USER_ERROR",
    payload: msg,
  };
};
export const getCompanyWithUser = (id) => {
  return (dispatch) => {
    dispatch(getCompanyWithUserRequest());
    API.get(`/company/get-companies-with-userId/${id}`)
      .then((res) => {
        let getCompanyListByUser = res.data?.data;
        dispatch(getCompanyWithUserSuccess(getCompanyListByUser));
      })
      .catch((error) => {
        dispatch(getCompanyWithUserError(error?.response?.data?.message));
      });
  };
};

// Is getting User
export const getUserRequest = () => {
  return {
    type: "GET_USER_REQUEST",
  };
};
export const getUserSuccess = (data) => {
  return {
    type: "GET_USER_SUCCESS",
    payload: data,
  };
};
export const getUserError = (msg) => {
  return {
    type: "GET_USER_ERROR",
    payload: msg,
  };
};
export const getUser = (id, handleDangerVisibleForUserDetails) => {
  return (dispatch) => {
    dispatch(getUserRequest());
    API.get(`/user/userdetails/${id}`)
      .then((res) => {
        let getUserDetails = res.data;
        dispatch(getUserSuccess(getUserDetails));
      })
      .catch((error) => {
        dispatch(getUserError(error?.response?.data?.message || ""));
        if (id) {
          handleDangerVisibleForUserDetails();
        }
      });
  };
};

// Post Production Invoice
export const postProductionInvoiceRequest = () => {
  return {
    type: "POST_DEFAULT_PRODUCTION_INVOICE_REQUEST",
  };
};
export const postProductionInvoiceSuccess = (data) => {
  return {
    type: "POST_DEFAULT_PRODUCTION_INVOICE_SUCCESS",
    payload: data,
  };
};
export const postProductionInvoiceError = (msg) => {
  return {
    type: "POST_DEFAULT_PRODUCTION_INVOICE_ERROR",
    payload: msg,
  };
};
export const postProductionInvoice = (
  data,
  setFormData,
  handleVisible,
  handleDangerVisible,
) => {
  return (dispatch) => {
    dispatch(postProductionInvoiceRequest());
    API.post(`/invoice/post-default-production-invoice`, data)
      .then((res) => {
        let postDefaultProductionInvoice = res.data;
        dispatch(postProductionInvoiceSuccess(postDefaultProductionInvoice));
        handleVisible(postDefaultProductionInvoice.message);
        setFormData({
          userId: "",
          companyId: "",
          HSCodeName: "",
          HSCodeId: "",
        });
      })
      .catch((error) => {
        dispatch(postProductionInvoiceError(error?.response?.data?.message));
        handleDangerVisible(error?.response?.data?.message);
      });
  };
};
